import { FormikTextField } from "@pinkyhead/dovekit";
import { fetcher, Methods } from "../../../../api";

export const filtersList = [
  {
    id: 0,
    tabName: 'physician',
    filters: [
      [
        {
          id: 0,
          name: 'first_name',
          component: FormikTextField,
          label: 'First Name',
          placeholder: 'First Name'
        },
        {
          id: 1,
          name: 'last_name',
          component: FormikTextField,
          label: 'Last Name',
          placeholder: 'Last Name'
        }
      ],
    ]
  },
  {
    id: 1,
    tabName: 'hospital',
    filters: [
      [
        {
          id: 0,
          name: 'hospital_name',
          component: FormikTextField,
          label: 'Hospital Name',
          placeholder: 'Hospital Name'
        }
      ],
    ]
  },
  {
    id: 2,
    tabName: 'clinic',
    filters: [
      [
        {
          id: 0,
          name: 'clinic_name',
          component: FormikTextField,
          label: 'Clinic Name',
          placeholder: "Clinic Name"
        }
      ],
    ]
  },
  {
    id: 3,
    tabName: 'nfp',
    filters: [
      [
        {
          id: 0,
          name: 'name',
          component: FormikTextField,
          label: 'Non-For-Profit Name',
          placeholder: 'Non-For-Profit Name'
        }
      ],
    ]
  },
  {
    id: 4,
    tabName: 'other healthcare',
    filters: [
      [
        {
          id: 0,
          name: 'first_name',
          component: FormikTextField,
          label: 'First Name',
          placeholder: 'First Name'
        },
        {
          id: 1,
          name: 'last_name',
          component: FormikTextField,
          label: 'Last Name',
          placeholder: 'Last Name'
        }
      ],
    ]
  },
  {
    id: 5,
    tabName: 'Business',
    filters: [
      [
        {
          id: 0,
          name: "business_name",
          component: FormikTextField,
          label: "Business Name",
          placeholder: "Business Name"
        }
      ]
    ]
  }
]

export const initialValues = {
  is_recommended: false,
  is_premium: false,
  is_claimed: false,
  state: null,
  city: null,
  healthcare_professionals: "",
  non_for_profit_name: "",
  clinic_name: "",
  hospital_name: "",
  first_name: "",
  last_name: "",
  speciality: null,
  gender: "",
  business_name: "",
  category: null,
  is_board_certified: false,
  rating_from: 0,
}

export const fetchSpeciality = async (searchValue: string) => {
  return fetcher({
    method: Methods.get,
    url: `/api/v1/physician-profile/specialties/?q=${encodeURIComponent(searchValue)}`,
  }).then((res) => {
    return res.map((each: { id: number, name: string}) => {
      return {
        id: each.id,
        name: each.name,
        value: each.name
      }
    })
  })
}

export const fetchBusinessCategory = async (searchValue: string) => {
  return fetcher({
    method: Methods.get,
    url: `/dovebiz/api/business/business-category/?name=${encodeURIComponent(searchValue)}`
  }).then((res) => {
    return res.results.map((each: { id: number, name: string }) => {
      return {
        id: each.id,
        name: each.name,
        value: each.name
      }
    })
  })
}

export const generatePseudorandomId = (length: number) => {
  const chars = '0123456789';
  return Array.from(Array(length)).reduce((prev: string) => {
    return prev + chars.charAt(Math.floor(Math.random() * chars.length))
  }, '')
}
